import { cn } from "@/lib/cn";

/** The Sweet Coin: the pink coin stamped with an S (public/brand/sweet-coin-*.webp, from the owner's logo). */
export const SWEET_COIN_SRC = "/brand/sweet-coin-256.webp";

export function SweetCoin({ size = 24, className }: { size?: number; className?: string }) {
  return (
    // eslint-disable-next-line @next/next/no-img-element -- a small decorative image at a fixed size, in several resolutions.
    <img
      src={SWEET_COIN_SRC}
      srcSet="/brand/sweet-coin-128.webp 128w, /brand/sweet-coin-256.webp 256w, /brand/sweet-coin-512.webp 512w"
      sizes={`${size}px`}
      width={size}
      height={size}
      alt=""
      aria-hidden
      draggable={false}
      decoding="async"
      className={cn("shrink-0", className)}
    />
  );
}
